import React from 'react';
import styled from 'styled-components';
import { highlightedTextStyles, highlightedTextUnderlineStyles } from '../styles';

const HighlightedTextUnderline = styled.div<{ hasNoText: boolean }>`
    ${({ hasNoText }) => hasNoText && `width: 150px;`}
    display: ${({ hasNoText }) => (hasNoText ? `inline-block` : `unset`)};
    ${highlightedTextUnderlineStyles}
`;

const HighlightedText = styled.span`
    ${highlightedTextStyles}
`;

export const Answer = ({ text }: { text?: React.ReactNode }) => (
    <HighlightedTextUnderline hasNoText={!text}>
        <HighlightedText>{text}</HighlightedText>
    </HighlightedTextUnderline>
);
